export default __webpack_public_path__ + "static/media/CT_Verizon.48920001.png";